const VISITOR_KEY = 'cs_visitor_id';
const COOKIE_NAME = 'cs_visitor_id';
function readCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match?.[1] ? decodeURIComponent(match[1]) : null;
}
export function getVisitorId() {
    return readCookie(COOKIE_NAME) || localStorage.getItem(VISITOR_KEY);
}
export function saveVisitorId(visitorId) {
    if (!visitorId)
        return;
    localStorage.setItem(VISITOR_KEY, visitorId);
}
